import { Box, Button, Grid } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { AxiosRequest } from "../../../Url";
import ContextMenu from "../../NotWorkArea(Side&Head)/ContextMenu";
import { GridLoader } from "../../rcsgrid/createGridTools";
import { DocFieldType } from "../../Tools/Consts";
import { smetaModals } from "../../Tools/modalManager";
import { EditStyle } from "../../Tools/ProjectX";
import { getObjText, setParamObjectText } from "../../Tools/Requests";
import {
  defaultFieldInfo,
  getDateOfInt,
  getDefaultMenu,
  getIntOfStrDate,
  getStrDateOfDateObj,
} from "../../Tools/Tools";
import { getParamColumnsOptions } from "../../rcsgrid/GridTools/parseColumnTools";

/**
 * @param {Object} props
 * @param {string} [props.Module]
 * @param {string | number} [props.DataType]
 * @param {string | number} [props.EditStyle]
 * @param {string | number} [props.Options]
 * @param {Map} props.paramsRequest
 * @param {Function} [props.onSelect]
 * @param {string} [props.smetaModalId]
 */

export default function DialogHistory(props) {
  const gridPanelRef = useRef();
  const [mainGrid, setMainGrid] = useState();
  const records = useRef([]);
  const currentDay = useRef();
  const valueList = useRef([]);

  useEffect(() => {
    getParamHistory().then((res) => {
      const result = [];
      if (res?.Items?.items?.length) {
        res.Items.items.forEach((item, index) => {
          result.push(item);
          result[index].UsedDate = item.UsedDate
            ? {
                text: getDateOfInt(result[index].UsedDate),
                id: result[index].UsedDate,
              }
            : "";
          if (Number(props.EditStyle) === EditStyle.Check) {
            result[index].CheckField = { text: "", id: item.ObjRef || "0" };
            result[index].Text = "";
            result[index].EditVal = "";
          }
        });
      }
      if (res.UsedDate) {
        currentDay.current = {
          text: getDateOfInt(res.UsedDate),
          id: res.UsedDate,
        };
      } else {
        const strDate = getStrDateOfDateObj(new Date());
        currentDay.current = { text: strDate, id: getIntOfStrDate(strDate) };
      }
      if (res.Values) {
        Object.values(res.Values).forEach((item) => {
          if (typeof item === "object") {
            valueList.current.push({ label: item.text, id: item.id });
          } else {
            valueList.current.push({ label: item });
          }
        });
      }
      records.current = result;
      mainGridLoader();
    });
  }, []);

  async function deleteRecord(request) {
    const deletedID = gridPanelRef.current.grid.source.getFieldTextSync("ID", request.RecordIndex);
    const deletedIndex = records.current.findIndex((record) => record.ID === deletedID);
    if (deletedIndex !== -1) records.current.splice(deletedIndex, 1);
    return {
      Command: "DeleteRecord",
      RecordIndex: records.current.length === 0 ? 0 : request.RecordIndex - 1,
      RecordCount: records.current.length,
      UpdatesPending: "1",
      RecordKey: {},
    };
  }

  function createRecord() {
    const index = records.current.length ? gridPanelRef.current.grid.source.activeRecord + 1 : 0;
    const newRecords = [...records.current];
    newRecords.splice(index, 0, { UsedDate: currentDay.current });
    return {
      index: index,
      records: newRecords,
      keys: ["UsedDate"],
      titleKey: "Text",
    };
  }

  async function checkFieldText(request) {
    const val = await getObjText(props.Module, props.DataType, request.ObjRef, "-1");
    return { Text: val.Text, ObjRef: request.ObjRef, EditVal: val.Text };
  }

  async function mainGridLoader() {
    const res = await GridLoader(gridPanelRef.current, props, {
      localGrid: true,
      refresh: false,
      Columns: getColumns(),
      defaultFields: getDefaultFields(),
      keyField: "ID",
      recordKeys: ["ID", "UsedDate", "ObjRef", "Text", "EditVal", "CheckField"],
      titleKey: "Text",
      getFieldText: getFieldText,
      checkFieldText: checkFieldText,
      onPostRecord: onPostRecord,
      createRecord: createRecord,
      deleteRecord: deleteRecord,
      getRecords: () => records.current,
      Rights: "-1",
    });
    setMainGrid(res);
  }

  function findFreeId(records) {
    const ids = records.map((record) => parseInt(record.ID, 10)).filter((id) => !isNaN(id));
    if (ids.length === 0) {
      return "1";
    }
    for (let i = 1; ; i++) {
      if (!ids.includes(i)) {
        return i.toString();
      }
    }
  }

  async function onPostRecord(request, requestData) {
    let attributeIndex = 0;
    if (request.NewRecord === "1") {
      records.current.splice(request.RecordIndex, 0, {
        ID: findFreeId(records.current),
        UsedDate: currentDay.current,
      });
      if (requestData.length > 3) {
        attributeIndex = requestData.length - 1;
      } else attributeIndex = 1;
    }
    const modifiedField = request.RecordSet.Attributes[attributeIndex],
      modifiedData = requestData[attributeIndex];
    const record = records.current[request.RecordIndex];
    if (modifiedField === "UsedDate") {
      let newUsedDate = "";
      if (modifiedData.id)
        newUsedDate = {
          text: getDateOfInt(modifiedData.id),
          id: modifiedData.id,
        };
      record.UsedDate = newUsedDate;
      return;
    }

    if (modifiedField === "CheckField") {
      record.CheckField = modifiedData;
      record.ObjRef = modifiedData ? "1" : "";
      return;
    }

    let newText = "",
      newObjRef = "",
      newEditVal = "",
      json;
    if (props.EditStyle == EditStyle.PickList && props.Module === undefined) {
      newText = modifiedData.text;
      newEditVal = modifiedData.text;
      newObjRef = modifiedData.id;
    } else if (props.EditStyle == EditStyle.Check) {
      newObjRef = modifiedData.id;
    } else if (modifiedData) {
      if (!modifiedData.id) {
        json = await setParamObjectText(props.Module, props.DataType, record.ObjRef, modifiedData.text);
        newText = json.Text;
        newObjRef = json.ObjRef;
        newEditVal = json.EditVal || newText;
      } else {
        newObjRef = modifiedData.id;
        newText = (await getObjText(props.Module, props.DataType, newObjRef, "-1")).Text;
        newEditVal = newText;
      }
    }
    record.ObjRef = newObjRef;
    record.Text = newText;
    record.EditVal = newEditVal;
  }

  async function textDropDownList() {
    if (props.Module) {
      const params = new Map();
      params.set("prefix", props.Module).set("comand", "GetObjectValues").set("ObjType", props.DataType);
      let json = await AxiosRequest(true, params);
      json = Object.values(json.Items);
      return json.map((item) => {
        return { label: item.text, id: item.id };
      });
    } else {
      return valueList.current;
    }
  }

  function getColumns() {
    return {
      title: [
        {
          fieldName: "UsedDate",
          title: "Дата",
          width: 100,
          fieldInfo: {
            ...defaultFieldInfo,
            DataType: DocFieldType.IntDate,
            EditStyle: EditStyle.Calendar,
          },
        },
        {
          fieldName: "Text",
          title: "Значение",
          width: 200,
          fieldInfo: {
            ...defaultFieldInfo,
            onDropDownList: textDropDownList,
            DataType: props.DataType,
            EditStyle: props.EditStyle,
            options: getParamColumnsOptions(props.Options || 0),
            Module: props.Module,
            CheckField: "CheckField",
          },
        },
      ],
    };
  }

  function getDefaultFields() {
    return [
      {
        Name: "ID",
        Title: "ID",
        Width: "7",
      },
      {
        Name: "UsedDate",
        Title: "Дата",
        Width: "10",
      },
      {
        Name: "ObjRef",
        Title: "ObjRef",
        Width: "7",
      },
      {
        Name: "Text",
        Title: "Значение",
        Width: "20",
      },
      {
        Name: "EditVal",
        Title: "Наименование для редактора",
        Width: "30",
      },
      {
        Name: "CheckField",
        Title: "",
        Width: "30",
      },
    ];
  }

  function getFieldText(request) {
    if (records.current.length) {
      let val = request.FieldName === "Text" ? "EditVal" : request.FieldName;
      if (gridPanelRef.current.grid.source.getState() === 3) {
        if (val === "EditVal") return { Text: "" };
        return { Text: currentDay.current.text };
      }
      const recVal = records.current[request.RecordIndex];
      return { Text: recVal[val]?.text || recVal[val] };
    }
    return { Text: "" };
  }

  function getParamHistory() {
    const params = props.paramsRequest;
    params.set("comand", "GetParamHistory");
    return AxiosRequest(true, params);
  }

  async function setParamHistory() {
    const params = props.paramsRequest;
    params.set("comand", "SetParamHistory");
    const data = [];
    records.current.forEach((element) => {
      const dataItem = {};
      if (element.UsedDate.id) dataItem.UsedDate = element.UsedDate.id;
      if (element.ObjRef) dataItem.ObjRef = element.ObjRef;
      data.push(dataItem);
    });
    const json = await AxiosRequest(true, params, { Items: data });
    props.onSelect?.(json);
  }

  return (
    <>
      <Box style={{ width: "100%", height: "calc(100% - 40px)" }}>
        <Grid
          style={{
            width: "100%",
            height: "100%",
            border: "1px solid #cccccc",
            position: "relative",
            overflow: "hidden",
          }}
        >
          <ContextMenu for="grid" Menu={getDefaultMenu("history")} refs={{ current: mainGrid }}>
            <div id={`rcgrid_panel`} ref={gridPanelRef} style={{ width: "100%", height: "100%" }}></div>
          </ContextMenu>
        </Grid>
      </Box>
      <Box style={{ height: "35px", width: "100%", marginTop: "5px" }}>
        <Grid container direction="row" justifyContent="flex-end" alignItems="center">
          <Grid item>
            <Button
              size="small"
              variant="outlined"
              style={{ textTransform: "none", marginRight: "10px" }}
              value="1"
              className="button_Modal_Select"
              onClick={() => {
                setParamHistory();
                smetaModals.close(props.smetaModalId);
              }}
            >
              Выбрать
            </Button>
            <Button
              size="small"
              variant="outlined"
              style={{ textTransform: "none" }}
              value="2"
              className="button_Modal_Close"
              onClick={() => {
                smetaModals.close(props.smetaModalId);
              }}
            >
              Отмена
            </Button>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
